// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var fallback = "_5f-5";
export var fallbackIcon = "_5f-6";
export var hidden = "_5f-2";
export var image = "_5f-3";
export var loaded = "_5f-4";
export var placeholder = "_5f-1";